// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Base Container === */
.ta-container {
  font-family: 'Inter', sans-serif;
  /* background-color: #f9fafb; */
  color: #1f2937;

}
 
.section-card {
  background: linear-gradient(180deg, #f9f6e6 0%, #d1fae5 100%);
  padding: 60px 50px 60px 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
  position: relative;
}

.section-content {
  max-width: 550px;
  z-index: 2;
}

.section-content h1 {

  font-weight: 800;
  color: #3b5643;
  margin-bottom: 0.5rem;
  font-size: 40px;
}

.section-content .subtitle {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #374151;
}

.section-content .description {
  font-size: 18px;
  color: #3a3f46;
  margin-bottom: 2rem;
  max-width: 500px;
  line-height: 1.6;
}

.btn-primary {
  background-color: #10b981;
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 18px;
  border: none;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #059669;
   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

/* === Right-Side Image === */
.section-image {
  flex: 1 1;
  max-width: 550px;
  display: flex;
  margin-right: 90px;
  justify-content: center;
  align-items: center;

 
}

.section-image img {
  width: 120%;

  /* border-radius: 1.5rem; */
  /* box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1); */
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.wallet-features {
  text-align: center;
  padding: 4rem 1.5rem;
  background: #f9fafb;
}

.wallet-features h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.wallet-subtitle {
  font-size: 1.125rem;
  color: #3e3f41;
  margin-bottom: 2.5rem;
  font-weight: 500;
}

.wallet-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.wallet-card {
  background: #ffffff;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.wallet-card:hover {
  transform: translateY(-6px);
}

.wallet-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #fff;
}

.wallet-card h3 {
  font-size: 1.25rem;
  color: #111827;
  margin-bottom: 0.625rem;
  font-weight: 600;
}

.wallet-card p {
  font-size: 1rem;
  color: #6b7280;
}

/* Mini card styles */
.wallet-mini-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 2.5rem;
}

.wallet-mini-card {
  background: #ffffff;
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: transform 0.3s ease;
}

.wallet-mini-card:hover {
  transform: translateY(-6px);
}

.wallet-mini-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  margin: 0 auto 0.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: #fff;
}

.wallet-mini-text {
  font-size: 1.125rem;
  font-weight: 500;
  color: #111827;
}

/* Responsive Breakpoints */
@media (max-width: 1200px) {
  .wallet-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .wallet-mini-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .wallet-grid {
    grid-template-columns: 1fr;
  }

  .wallet-mini-row {
    grid-template-columns: 1fr;
  }

  .wallet-features {
    padding: 3rem 1rem;
  }

  .wallet-features h2 {
    font-size: 2rem;
  }

  .wallet-subtitle {
    font-size: 1rem;
  }

  .wallet-card,
  .wallet-mini-card {
    padding: 1.25rem;
  }
}

@media (min-width: 1920px) {
  .wallet-features {
    padding: 6rem 10rem;
  }

  .wallet-features h2 {
    font-size: 3rem;
  }

  .wallet-subtitle {
    font-size: 1.25rem;
  }
}

.secure-section {
  padding: 50px 100px;
  background: linear-gradient(to bottom, #0e3931 0%, #142745 40%, #104a3e 100%);
  color: white;
  text-align: center;
  font-family: 'Inter', sans-serif;
}

.secure-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.secure-subtitle {
  font-size: 1.25rem;
  color: #d1d5db;
  margin-bottom: 2rem;
}

.secure-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
  padding: 20px;
}

.secure-card {
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  color: #fdfeff;
  text-align: center;
  transition: transform 0.3s ease;
}

.secure-card:hover {
  transform: translateY(-6px);
}

.secure-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

/* Icon Backgrounds */
.bg-blue {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
}
.bg-green {
  background: linear-gradient(135deg, #10b981, #34d399);
}
.bg-purple {
  background: linear-gradient(135deg, #a855f7, #c084fc);
}
.bg-orange {
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
}

.secure-card h3 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.secure-card p {
  font-size: 1rem;
  color: #c3c5c7;
}

/* Subgrid */
.secure-subgrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  text-align: left;
  max-width: 1000px;
  margin: 0 auto;
}

.secure-block h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: white;
}

.secure-block p {
  font-size: 1rem;
  color: #d1d5db;
  margin-bottom: 1rem;
}

.icon-row {
  display: flex;
  gap: 1rem;
}

.icon-circle {
  width: 2.75rem;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: white;
  font-size: 1.2rem;
}

.status-box {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 1.5rem;
  border-radius: 0.75rem;
  color: #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.check-icon {
  color: #34d399;
  font-size: 1.2rem;
}

/* Responsive Design */
@media (max-width: 992px) {
  .secure-section {
    padding: 40px 40px;
  }

  .secure-title {
    font-size: 2rem;
  }

  .secure-subtitle {
    font-size: 1.125rem;
  }
}

@media (max-width: 576px) {
  .secure-section {
    padding: 30px 20px;
  }

  .secure-title {
    font-size: 1.75rem;
  }

  .secure-subtitle {
    font-size: 1rem;
  }

  .secure-grid {
    padding: 0;
    gap: 1.5rem;
  }

  .secure-card {
    padding: 1.5rem 1rem;
  }

  .secure-subgrid {
    gap: 1.5rem;
  }

  .status-box {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

@media (min-width: 1920px) {
  .secure-section {
    padding: 100px 200px;
  }

  .secure-title {
    font-size: 3rem;
  }

  .secure-subtitle {
    font-size: 1.5rem;
  }
}










.benefits-section {
  padding: 60px 80px;
  text-align: center;
  background-color: #ffffff;
  font-family: 'Inter', sans-serif;
}

.benefits-section h3 {
  font-size: 2.5rem;
  font-weight: 700;
}

.toggle-buttons {
  margin: 20px 0 40px;
}

.tab-btn {
  border: none;
  background: transparent;
  font-size: 1.25rem;
  font-weight: 600;
  padding: 10px 24px;
  margin: 0 8px;
  border-radius: 999px;
  color: #111827;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background-color: #10b981;
  color: white;
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 20px 130px;
}

.benefits-card {
  background: #f9fafb;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  transition: transform 0.3s ease;
}

.benefits-card:hover {
  transform: translateY(-5px);
}

.icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.benefits-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.benefits-card p {
  font-size: 1.125rem;
  color: #6b7280;
}

.cta-banner {
  background: linear-gradient(to right, #f0fdf4, #ecfdf5);
  padding: 40px 30px;
  text-align: center;
  margin-top: 60px;
  border-radius: 1rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  max-width: 850px;
  margin-left: auto;
  margin-right: auto;
}

.cta-banner h4 {
  color: #4b5563;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.cta-banner p {
  color: #4b5563;
  font-size: 1.125rem;
  margin-bottom: 1.5rem;
}

.cta-button {
  background-color: #10b981;
  color: white;
  padding: 12px 24px;
  border: none;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.cta-button:hover {
  background-color: #0ea672;
}

/* ------------------ Responsive Breakpoints ------------------ */
@media (max-width: 1200px) {
  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
    padding: 20px 60px;
  }
}

@media (max-width: 768px) {
  .benefits-section {
    padding: 40px 30px;
  }

  .benefits-section h3 {
    font-size: 2rem;
  }

  .tab-btn {
    font-size: 1rem;
    padding: 8px 16px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 1.5rem;
  }

  .benefits-card {
    padding: 1.5rem;
  }

  .cta-banner h4 {
    font-size: 1.5rem;
  }

  .cta-banner p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
 .toggle-buttons {
    flex-wrap: wrap; /* allow wrap only on very small screens */
    gap: 10px;
  }

  .tab-btn {
    font-size: 1rem;
    padding: 8px 16px;
  }
}

@media (min-width: 1920px) {
  .benefits-section {
    padding: 100px 200px;
  }

  .benefits-grid {
    padding: 40px 240px;
    gap: 2.5rem;
  }

  .benefits-section h3 {
    font-size: 3rem;
  }

  .benefits-card h3 {
    font-size: 1.5rem;
  }

  .benefits-card p {
    font-size: 1.25rem;
  }

  .cta-banner h4 {
    font-size: 2rem;
  }

  .cta-banner p {
    font-size: 1.25rem;
  }
}

/* ========= Responsive Breakpoints ========= */
/* === Base Styling === */
.section-card {
  background: linear-gradient(180deg, #ffffff 0%, #d1fae5 100%);
  /* padding: 100px 40px 100px 150px;  */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}



.btn-primary {
  background-color: #10b981;
  color: white;
  /* padding: 0.75rem 2rem; */
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  box-shadow: 0 5px 15px rgba(16, 185, 129, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #059669;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.5);
}

.section-image img {
  max-width: 100%;
  height: 350px;
  border-radius: 12px;
}


/* === Responsive === */
@media (max-width: 1024px) {
  .section-card {
    flex-direction: column;
    padding: 80px 20px;
    text-align: center;
  }

  .section-content h1 {
    font-size: 2.5rem;
  }

  .section-content .subtitle {
    font-size: 1.4rem;
  }

  .section-content .description {
    font-size: 1rem;
  }

  .btn-primary {
    font-size: 0.95rem;
    padding: 0.6rem 1.8rem;
  }

  .section-image {
    margin-top: 30px;
  }
}
@media (max-width: 768px) {
  .section-card {
    flex-direction: column;
    padding: 50px 20px;
    text-align: left;
    align-items: flex-start;
  }

  .section-content {
    text-align: left;
    width: 100%;
  }

  .section-content h1 {
    font-size: 1.8rem; /* smaller for mobile */
    line-height: 1.3;
    margin-bottom: 0.5rem;
  }

  .section-content .subtitle {
    font-size: 1.2rem;
    line-height: 1.4;
    margin-bottom: 1rem;
    word-wrap: break-word; /* ✅ ensures wrapping */
  }

  .section-content .description {
    font-size: 1rem;
    line-height: 1.6;
    word-wrap: break-word; /* ✅ ensures no cutoff */
    max-width: 100%;
  }

  .btn-primary {
    font-size: 1rem;
    padding: 10px 20px;
  }

  .section-image {
    width: 100%;
    margin-top: 20px;
  }

  .section-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .section-card {
    padding: 50px 10px;
  }

  .section-content h1 {
    font-size: 1.6rem;
  }

  .section-content .subtitle {
    font-size: 1rem;
  }

  .section-content .description {
    font-size: 0.9rem;
  }

  .btn-primary {
    font-size: 0.85rem;
    padding: 0.45rem 1.2rem;
  }

  .section-image img {
    border-radius: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaPayxPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,cAAc;;AAEhB;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;IACV,iDAAiD;EACnD,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;GACxB,iDAAiD;AACpD;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;;;AAGrB;;AAEA;EACE,WAAW;;EAEX,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,6EAA6E;EAC7E,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE;IACE,qCAAqC;IACrC,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;CACC;IACG,eAAe,EAAE,0CAA0C;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;;AAGA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB,EAAE,uBAAuB;IAC1C,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB,EAAE,uBAAuB;EAChD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB,EAAE,wBAAwB;IAC/C,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* === Base Container === */\r\n.ta-container {\r\n  font-family: 'Inter', sans-serif;\r\n  /* background-color: #f9fafb; */\r\n  color: #1f2937;\r\n\r\n}\r\n \r\n.section-card {\r\n  background: linear-gradient(180deg, #f9f6e6 0%, #d1fae5 100%);\r\n  padding: 60px 50px 60px 90px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 2rem;\r\n  position: relative;\r\n}\r\n\r\n.section-content {\r\n  max-width: 550px;\r\n  z-index: 2;\r\n}\r\n\r\n.section-content h1 {\r\n\r\n  font-weight: 800;\r\n  color: #3b5643;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 40px;\r\n}\r\n\r\n.section-content .subtitle {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  color: #374151;\r\n}\r\n\r\n.section-content .description {\r\n  font-size: 18px;\r\n  color: #3a3f46;\r\n  margin-bottom: 2rem;\r\n  max-width: 500px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #10b981;\r\n  color: white;\r\n  padding: 0.75rem 2rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  border: none;\r\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #059669;\r\n   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n}\r\n\r\n/* === Right-Side Image === */\r\n.section-image {\r\n  flex: 1;\r\n  max-width: 550px;\r\n  display: flex;\r\n  margin-right: 90px;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n \r\n}\r\n\r\n.section-image img {\r\n  width: 120%;\r\n\r\n  /* border-radius: 1.5rem; */\r\n  /* box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1); */\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.wallet-features {\r\n  text-align: center;\r\n  padding: 4rem 1.5rem;\r\n  background: #f9fafb;\r\n}\r\n\r\n.wallet-features h2 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.wallet-subtitle {\r\n  font-size: 1.125rem;\r\n  color: #3e3f41;\r\n  margin-bottom: 2.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.wallet-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 24px;\r\n}\r\n\r\n.wallet-card {\r\n  background: #ffffff;\r\n  border-radius: 1rem;\r\n  padding: 1.5rem;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  text-align: center;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.wallet-card:hover {\r\n  transform: translateY(-6px);\r\n}\r\n\r\n.wallet-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 12px;\r\n  margin: 0 auto 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.4rem;\r\n  color: #fff;\r\n}\r\n\r\n.wallet-card h3 {\r\n  font-size: 1.25rem;\r\n  color: #111827;\r\n  margin-bottom: 0.625rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.wallet-card p {\r\n  font-size: 1rem;\r\n  color: #6b7280;\r\n}\r\n\r\n/* Mini card styles */\r\n.wallet-mini-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 24px;\r\n  margin-top: 2.5rem;\r\n}\r\n\r\n.wallet-mini-card {\r\n  background: #ffffff;\r\n  border-radius: 1rem;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.wallet-mini-card:hover {\r\n  transform: translateY(-6px);\r\n}\r\n\r\n.wallet-mini-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 12px;\r\n  margin: 0 auto 0.625rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 1.5rem;\r\n  color: #fff;\r\n}\r\n\r\n.wallet-mini-text {\r\n  font-size: 1.125rem;\r\n  font-weight: 500;\r\n  color: #111827;\r\n}\r\n\r\n/* Responsive Breakpoints */\r\n@media (max-width: 1200px) {\r\n  .wallet-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .wallet-mini-row {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .wallet-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .wallet-mini-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .wallet-features {\r\n    padding: 3rem 1rem;\r\n  }\r\n\r\n  .wallet-features h2 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .wallet-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .wallet-card,\r\n  .wallet-mini-card {\r\n    padding: 1.25rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n  .wallet-features {\r\n    padding: 6rem 10rem;\r\n  }\r\n\r\n  .wallet-features h2 {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .wallet-subtitle {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n.secure-section {\r\n  padding: 50px 100px;\r\n  background: linear-gradient(to bottom, #0e3931 0%, #142745 40%, #104a3e 100%);\r\n  color: white;\r\n  text-align: center;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.secure-title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.secure-subtitle {\r\n  font-size: 1.25rem;\r\n  color: #d1d5db;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.secure-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: 2rem;\r\n  margin-bottom: 3rem;\r\n  padding: 20px;\r\n}\r\n\r\n.secure-card {\r\n  border-radius: 1rem;\r\n  padding: 2rem 1.5rem;\r\n  color: #fdfeff;\r\n  text-align: center;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.secure-card:hover {\r\n  transform: translateY(-6px);\r\n}\r\n\r\n.secure-icon {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 12px;\r\n  margin: 0 auto 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n}\r\n\r\n/* Icon Backgrounds */\r\n.bg-blue {\r\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\r\n}\r\n.bg-green {\r\n  background: linear-gradient(135deg, #10b981, #34d399);\r\n}\r\n.bg-purple {\r\n  background: linear-gradient(135deg, #a855f7, #c084fc);\r\n}\r\n.bg-orange {\r\n  background: linear-gradient(135deg, #f59e0b, #fbbf24);\r\n}\r\n\r\n.secure-card h3 {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.secure-card p {\r\n  font-size: 1rem;\r\n  color: #c3c5c7;\r\n}\r\n\r\n/* Subgrid */\r\n.secure-subgrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\r\n  gap: 2rem;\r\n  text-align: left;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.secure-block h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n  color: white;\r\n}\r\n\r\n.secure-block p {\r\n  font-size: 1rem;\r\n  color: #d1d5db;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.icon-row {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.icon-circle {\r\n  width: 2.75rem;\r\n  height: 2.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  color: white;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.status-box {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 0.75rem;\r\n  color: #e5e7eb;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.check-icon {\r\n  color: #34d399;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 992px) {\r\n  .secure-section {\r\n    padding: 40px 40px;\r\n  }\r\n\r\n  .secure-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .secure-subtitle {\r\n    font-size: 1.125rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .secure-section {\r\n    padding: 30px 20px;\r\n  }\r\n\r\n  .secure-title {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  .secure-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .secure-grid {\r\n    padding: 0;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .secure-card {\r\n    padding: 1.5rem 1rem;\r\n  }\r\n\r\n  .secure-subgrid {\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .status-box {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n  .secure-section {\r\n    padding: 100px 200px;\r\n  }\r\n\r\n  .secure-title {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .secure-subtitle {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.benefits-section {\r\n  padding: 60px 80px;\r\n  text-align: center;\r\n  background-color: #ffffff;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.benefits-section h3 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.toggle-buttons {\r\n  margin: 20px 0 40px;\r\n}\r\n\r\n.tab-btn {\r\n  border: none;\r\n  background: transparent;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  padding: 10px 24px;\r\n  margin: 0 8px;\r\n  border-radius: 999px;\r\n  color: #111827;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tab-btn.active {\r\n  background-color: #10b981;\r\n  color: white;\r\n  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.benefits-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 2rem;\r\n  padding: 20px 130px;\r\n}\r\n\r\n.benefits-card {\r\n  background: #f9fafb;\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.benefits-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.icon {\r\n  width: 60px;\r\n  height: 60px;\r\n  margin: 0 auto 1rem;\r\n  border-radius: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.benefits-card h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.benefits-card p {\r\n  font-size: 1.125rem;\r\n  color: #6b7280;\r\n}\r\n\r\n.cta-banner {\r\n  background: linear-gradient(to right, #f0fdf4, #ecfdf5);\r\n  padding: 40px 30px;\r\n  text-align: center;\r\n  margin-top: 60px;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\r\n  max-width: 850px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.cta-banner h4 {\r\n  color: #4b5563;\r\n  font-size: 1.75rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.cta-banner p {\r\n  color: #4b5563;\r\n  font-size: 1.125rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.cta-button {\r\n  background-color: #10b981;\r\n  color: white;\r\n  padding: 12px 24px;\r\n  border: none;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.cta-button:hover {\r\n  background-color: #0ea672;\r\n}\r\n\r\n/* ------------------ Responsive Breakpoints ------------------ */\r\n@media (max-width: 1200px) {\r\n  .benefits-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    padding: 20px 60px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .benefits-section {\r\n    padding: 40px 30px;\r\n  }\r\n\r\n  .benefits-section h3 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .tab-btn {\r\n    font-size: 1rem;\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .benefits-grid {\r\n    grid-template-columns: 1fr;\r\n    padding: 0;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .benefits-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .cta-banner h4 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .cta-banner p {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n .toggle-buttons {\r\n    flex-wrap: wrap; /* allow wrap only on very small screens */\r\n    gap: 10px;\r\n  }\r\n\r\n  .tab-btn {\r\n    font-size: 1rem;\r\n    padding: 8px 16px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n  .benefits-section {\r\n    padding: 100px 200px;\r\n  }\r\n\r\n  .benefits-grid {\r\n    padding: 40px 240px;\r\n    gap: 2.5rem;\r\n  }\r\n\r\n  .benefits-section h3 {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .benefits-card h3 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .benefits-card p {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .cta-banner h4 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .cta-banner p {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n/* ========= Responsive Breakpoints ========= */\r\n/* === Base Styling === */\r\n.section-card {\r\n  background: linear-gradient(180deg, #ffffff 0%, #d1fae5 100%);\r\n  /* padding: 100px 40px 100px 150px;  */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n\r\n\r\n.btn-primary {\r\n  background-color: #10b981;\r\n  color: white;\r\n  /* padding: 0.75rem 2rem; */\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  border: none;\r\n  box-shadow: 0 5px 15px rgba(16, 185, 129, 0.3);\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #059669;\r\n  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.5);\r\n}\r\n\r\n.section-image img {\r\n  max-width: 100%;\r\n  height: 350px;\r\n  border-radius: 12px;\r\n}\r\n\r\n\r\n/* === Responsive === */\r\n@media (max-width: 1024px) {\r\n  .section-card {\r\n    flex-direction: column;\r\n    padding: 80px 20px;\r\n    text-align: center;\r\n  }\r\n\r\n  .section-content h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n\r\n  .section-content .subtitle {\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  .section-content .description {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 0.95rem;\r\n    padding: 0.6rem 1.8rem;\r\n  }\r\n\r\n  .section-image {\r\n    margin-top: 30px;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .section-card {\r\n    flex-direction: column;\r\n    padding: 50px 20px;\r\n    text-align: left;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .section-content {\r\n    text-align: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .section-content h1 {\r\n    font-size: 1.8rem; /* smaller for mobile */\r\n    line-height: 1.3;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .section-content .subtitle {\r\n    font-size: 1.2rem;\r\n    line-height: 1.4;\r\n    margin-bottom: 1rem;\r\n    word-wrap: break-word; /* ✅ ensures wrapping */\r\n  }\r\n\r\n  .section-content .description {\r\n    font-size: 1rem;\r\n    line-height: 1.6;\r\n    word-wrap: break-word; /* ✅ ensures no cutoff */\r\n    max-width: 100%;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 1rem;\r\n    padding: 10px 20px;\r\n  }\r\n\r\n  .section-image {\r\n    width: 100%;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .section-image img {\r\n    width: 100%;\r\n    height: auto;\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .section-card {\r\n    padding: 50px 10px;\r\n  }\r\n\r\n  .section-content h1 {\r\n    font-size: 1.6rem;\r\n  }\r\n\r\n  .section-content .subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .section-content .description {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 0.85rem;\r\n    padding: 0.45rem 1.2rem;\r\n  }\r\n\r\n  .section-image img {\r\n    border-radius: 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
